interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  appId: string;
}

const prefix = () => {
  if (import.meta.env.DEV) return "VITE_DEV_";
  if (import.meta.env.MODE === "stag") return "VITE_STAG_";
  return "VITE_";
};

export const envVars = {
  // Choose the right Firebase config based on environment
  firebase: (() => {
    const config: FirebaseConfig = {
      apiKey: import.meta.env[`${prefix()}FIREBASE_API_KEY`] as string,
      authDomain: import.meta.env[`${prefix()}FIREBASE_AUTH_DOMAIN`] as string,
      projectId: import.meta.env[`${prefix()}FIREBASE_PROJECT_ID`] as string,
      appId: import.meta.env[`${prefix()}FIREBASE_APP_ID`] as string,
    };

    const deleteFunctionUrl = import.meta.env[
      `${prefix()}DELETE_FUNCTION_URL`
    ] as string;

    return { config, deleteFunctionUrl };
  })(),

  googleFormUrl: import.meta.env[`${prefix()}GOOGLE_FORM_URL`] as string,
};
